import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ModalComponent } from '../../components/modal/modal.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { UniversityService } from '../../services/university.service';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { ButtonComponent } from '../../components/button/button.component';

@Component({
  selector: 'app-transaction-history-list-page',
  imports: [HeaderComponent, CommonModule, ModalComponent, PluralPipe, AgGridListComponent, SelectInputComponent, SearchInputComponent, ButtonComponent],
  templateUrl: './transaction-history-list-page.component.html',
})
export class TransactionHistoryListPageComponent {
  page_name = 'Payments';
  params: any = {};
  selected_ids: any = {}
  items: any

  transaction_history_cols: any = [
    { headerName: 'Sr.No', field: 'SrNo', flex: 1 },
    { field: 'university', headerName: 'School', filter: true, flex: 1, },
    { field: 'program', headerName: 'Program', filter: true, flex: 1, },
    { field: 'exam', headerName: 'Exam', filter: true, flex: 1, },
    { field: 'subject', headerName: 'Subject', filter: true, flex: 1, },
    { field: 'payment_date', headerName: 'Payment Date', filter: true, flex: 1, },
    { field: 'payment_status', headerName: 'Payment Status', filter: true, flex: 1, },
    { headerName: "Actions", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', }
  ];
  actions(row: any) {
    let actions: any = []
    actions.push({ text: 'Download Receipt', shortcut: 'u', color: 'grey', icon: 'bx  bx-arrow-to-bottom', function: this.downloadDummyReceipt.bind(this) })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public us: UniversityService, public ar: ActivatedRoute,) { }

  async ngOnInit() {
    this.ar.queryParams.subscribe(async (params: any) => {
      this.params = { ...params }
      this.get_list();
    })
  }
  downloadDummyReceipt() {
    const text = `
  PAYMENT RECEIPT
  -----------------------
  Roll No: 12345
  Subject: English (001)
  Amount: ₹500
  Status: SUCCESS
  Date: ${new Date().toLocaleString()}
  `;

    const blob = new Blob([text], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = "Sem 1 Backlog English.txt";
    a.click();
  }


  async get_list(filter?: any) {
    try {
      // this.items = await this.us.get_list(filter);
      this.items = {
        "code": 200,
        "message": "Payment History Fetched Successfully",
        "count": 6,
        "data": [
          {
            "id": 1,
            "university": "SIU",
            "program": "BA - English",
            "exam": "Sem I Backlog",
            "subject": "English",
            "payment_date": "10/12/2025",
            "payment_status": "Success"
          },
          {
            "id": 2,
            "university": "MU",
            "program": "BCom - Accounts",
            "exam": "Sem II Regular",
            "subject": "Financial Accounting",
            "payment_date": "08/12/2025",
            "payment_status": "Failed"
          },
          {
            "id": 3,
            "university": "Pune University",
            "program": "BSc - Computer Science",
            "exam": "Sem III Backlog",
            "subject": "Data Structures",
            "payment_date": "05/12/2025",
            "payment_status": "Success"
          },
          {
            "id": 4,
            "university": "SIU",
            "program": "MBA - Finance",
            "exam": "Trimester I",
            "subject": "Business Economics",
            "payment_date": "02/12/2025",
            "payment_status": "Success"
          },
          {
            "id": 5,
            "university": "DU",
            "program": "BA - Psychology",
            "exam": "Sem IV Regular",
            "subject": "Cognitive Psychology",
            "payment_date": "28/11/2025",
            "payment_status": "Failed"
          },
          {
            "id": 6,
            "university": "Pune University",
            "program": "BCA",
            "exam": "Sem II Regular",
            "subject": "Operating Systems",
            "payment_date": "26/11/2025",
            "payment_status": "Success"
          }
        ]
      }

    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }

  async download_receipt(item: any, index: any) {
    this.selected_ids = item;
    console.log(this.selected_ids, "  this.selected_ids");

  }

}
